(function () {
  var BAR_SELECTOR = '[data-sc-cart-shipping-bar]';

  var REDUCED_SHIPPING_THRESHOLD = 50;
  var FREE_SHIPPING_THRESHOLD = 180;

  function isArabic() {
    return (
      document.documentElement.dir === 'rtl' ||
      (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0 ||
      window.location.pathname.indexOf('/ar') === 0
    );
  }

  function money(value, ar) {
    var formatted = Number(value || 0).toFixed(2).replace('.00', '');
    return ar ? formatted + ' ريال' : formatted + ' SR';
  }

  function getShippingInfo(total) {
    if (total >= FREE_SHIPPING_THRESHOLD) {
      return {
        fee: 0,
        progress: 100,
        remainingToReduced: 0,
        remainingToFree: 0,
        tier: 'free'
      };
    }

    if (total >= REDUCED_SHIPPING_THRESHOLD) {
      return {
        fee: 1,
        progress: Math.max(
          34,
          Math.min(99, (total / FREE_SHIPPING_THRESHOLD) * 100)
        ),
        remainingToReduced: 0,
        remainingToFree: FREE_SHIPPING_THRESHOLD - total,
        tier: 'reduced'
      };
    }

    return {
      fee: 23,
      progress: Math.max(
        5,
        Math.min(33, (total / REDUCED_SHIPPING_THRESHOLD) * 33)
      ),
      remainingToReduced: REDUCED_SHIPPING_THRESHOLD - total,
      remainingToFree: FREE_SHIPPING_THRESHOLD - total,
      tier: 'base'
    };
  }

  function setText(bar, selector, text) {
    var el = bar.querySelector(selector);
    if (el) el.textContent = text;
  }

  function setMilestoneText(bar, text) {
    setText(
      bar,
      '.sc-cart-shipping-bar__milestone-value .sc-cart-shipping-bar__milestone-text',
      text
    );
  }

  function setProgress(bar, progress) {
    var safeProgress = Math.max(0, Math.min(Number(progress || 0), 100));

    bar.style.setProperty('--sc-progress', safeProgress + '%');

    var fill = bar.querySelector('[data-sc-shipping-fill]');
    var truck = bar.querySelector('[data-sc-shipping-truck]');

    if (fill) {
      fill.style.width = safeProgress + '%';
    }

    if (truck) {
      truck.style.insetInlineStart = safeProgress + '%';

      truck.style.animation = 'none';
      void truck.offsetWidth;

      truck.style.animation =
        safeProgress >= 100
          ? 'scShippingBounce .7s ease'
          : 'scShippingFloat 2s ease-in-out infinite';
    }
  }

  function updateBarText(bar, info, ar) {
    if (ar) {
      setMilestoneText(bar, '180 ريال');

      if (info.tier === 'free') {
        setText(
          bar,
          '[data-sc-shipping-title]',
          'تهانينا! التوصيل مجاني لطلبك'
        );

        setText(
          bar,
          '[data-sc-shipping-message]',
          'تم الوصول إلى الحد المطلوب للتوصيل المجاني.'
        );

        setText(
          bar,
          '[data-sc-shipping-submessage]',
          '🎉 تم فتح التوصيل المجاني لهذا الطلب.'
        );

        return;
      }

      if (info.tier === 'reduced') {
        setText(
          bar,
          '[data-sc-shipping-title]',
          'رسوم التوصيل الحالية: 13 ريال'
        );

        setText(
          bar,
          '[data-sc-shipping-message]',
          'أضف ' + money(info.remainingToFree, true) + ' إضافية للحصول على توصيل مجاني.'
        );

        setText(
          bar,
          '[data-sc-shipping-submessage]',
          '🎉 التوصيل المجاني يبدأ عند 180 ريال.'
        );

        return;
      }

      setText(
        bar,
        '[data-sc-shipping-title]',
        'رسوم التوصيل الحالية: 23 ريال'
      );

      setText(
        bar,
        '[data-sc-shipping-message]',
        'أضف ' + money(info.remainingToReduced, true) + ' لتصبح رسوم التوصيل 13 ريال.'
      );

      setText(
        bar,
        '[data-sc-shipping-submessage]',
        '🎉 التوصيل المجاني يبدأ عند 180 ريال.'
      );

      return;
    }

    setMilestoneText(bar, '180 SR');

    if (info.tier === 'free') {
      setText(
        bar,
        '[data-sc-shipping-title]',
        'Great! Your order qualifies for free delivery'
      );

      setText(
        bar,
        '[data-sc-shipping-message]',
        'You have reached the free delivery threshold.'
      );

      setText(
        bar,
        '[data-sc-shipping-submessage]',
        '🎉 Free delivery is now unlocked for this order.'
      );

      return;
    }

    if (info.tier === 'reduced') {
      setText(
        bar,
        '[data-sc-shipping-title]',
        'Current delivery fee: 13 SR'
      );

      setText(
        bar,
        '[data-sc-shipping-message]',
        'Add ' + money(info.remainingToFree, false) + ' more to unlock free delivery.'
      );

      setText(
        bar,
        '[data-sc-shipping-submessage]',
        '🎉 Free delivery unlocks at 180 SR.'
      );

      return;
    }

    setText(
      bar,
      '[data-sc-shipping-title]',
      'Current delivery fee: 23 SR'
    );

    setText(
      bar,
      '[data-sc-shipping-message]',
      'Add ' + money(info.remainingToReduced, false) + ' more to reduce delivery to 13 SR.'
    );

    setText(
      bar,
      '[data-sc-shipping-submessage]',
      '🎉 Free delivery unlocks at 180 SR.'
    );
  }

  function updateBarFromCart(cart) {
    var bar = document.querySelector(BAR_SELECTOR);
    if (!bar || !cart) return;

    var ar = isArabic();
    var total = (cart.total_price || 0) / 100;
    var info = getShippingInfo(total);

    bar.classList.toggle('is-free', info.tier === 'free');
    bar.classList.toggle('is-reduced', info.tier === 'reduced');
    bar.classList.toggle('is-base', info.tier === 'base');

    bar.setAttribute('data-sc-shipping-tier', info.tier);
    bar.setAttribute('data-sc-cart-total', String(total));
    bar.setAttribute('data-sc-shipping-progress', String(info.progress));

    setProgress(bar, info.progress);
    updateBarText(bar, info, ar);
  }

  function fetchAndUpdate() {
    if (!document.querySelector(BAR_SELECTOR)) return;

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart request failed');
        return res.json();
      })
      .then(function (cart) {
        updateBarFromCart(cart);
      })
      .catch(function () {});
  }

  function scheduleUpdate(delay) {
    window.setTimeout(fetchAndUpdate, delay || 700);
  }

  document.addEventListener('DOMContentLoaded', fetchAndUpdate);

  document.addEventListener('cart:updated', fetchAndUpdate);
  document.addEventListener('cart:refresh', fetchAndUpdate);
  document.addEventListener('cart:change', fetchAndUpdate);
  document.addEventListener('t4s:cart:updated', fetchAndUpdate);
  document.addEventListener('t4s:cart:refresh', fetchAndUpdate);
  document.addEventListener('t4s:cart:change', fetchAndUpdate);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-quantity-value]')) {
      scheduleUpdate(700);
    }
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('[data-quantity-selector]') ||
      event.target.closest('[data-cart-remove]') ||
      event.target.closest('.t4s-page_cart__remove')
    ) {
      scheduleUpdate(900);
    }
  });

  if (window.fetch && !window.__scShippingBarFetchPatched) {
    window.__scShippingBarFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var url = '';

      try {
        url = typeof args[0] === 'string' ? args[0] : args[0].url || '';
      } catch (e) {}

      return originalFetch.apply(this, args).then(function (response) {
        if (
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/clear') !== -1
        ) {
          scheduleUpdate(500);
        }

        return response;
      });
    };
  }
})();